var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReportingCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 246,
    height: 185,
    viewBox: "0 0 246 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5438_171247)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 185,
    fill: "url(#paint0_linear_5438_171247)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter0_ddd_5438_171247)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.5,
    cy: -0.5,
    r: 210.5,
    fill: "#FFF2E9"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter1_ddd_5438_171247)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 134,
    fill: "#FFF2E9"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter2_ddd_5438_171247)"
  }, /*#__PURE__*/React.createElement("circle", {
    r: 74,
    fill: "#FFF2E9"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M171.971 160.611C171.971 161.953 171.726 162.925 171.242 163.501C170.951 163.799 170.596 164.029 170.204 164.173C169.811 164.318 169.391 164.373 168.973 164.336C168.553 164.377 168.128 164.321 167.734 164.171C167.339 164.021 166.986 163.782 166.702 163.473C166.161 162.618 165.911 161.615 165.989 160.61V147.691H160.055V160.907C160.055 163.521 160.843 165.545 162.397 166.922C163.938 168.287 166.15 168.979 168.973 168.979C171.882 168.979 174.12 168.274 175.625 166.882C177.13 165.49 177.907 163.468 177.907 160.893V147.691H171.971V160.611ZM172.801 148.51H177.077V160.896C177.077 163.236 176.398 165.049 175.058 166.287C173.719 167.524 171.665 168.163 168.974 168.163C166.362 168.163 164.336 167.54 162.952 166.315C161.58 165.1 160.885 163.281 160.885 160.91V148.51H165.16V160.611C165.078 161.796 165.388 162.976 166.044 163.972C166.402 164.384 166.855 164.705 167.364 164.911C167.873 165.116 168.424 165.2 168.972 165.155C169.512 165.196 170.054 165.115 170.557 164.919C171.06 164.723 171.512 164.417 171.878 164.024C172.489 163.297 172.799 162.148 172.799 160.611L172.801 148.51Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.619 169H211.192V164.261H202.527V159.913H210.512V155.175H202.527V152.41H211.193V147.671H196.62L196.619 169ZM197.448 148.501H210.364V151.582H201.697V156.001H209.682V159.082H201.697V165.087H210.364V168.168H197.448V148.501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.518 164.886H219.206C220.565 164.886 221.472 164.877 221.978 164.859C222.566 164.832 223.144 164.697 223.682 164.462C224.195 164.259 224.624 163.89 224.897 163.415C225.149 162.956 225.277 162.44 225.27 161.918C225.3 161.32 225.139 160.728 224.81 160.225C224.472 159.784 224.005 159.456 223.472 159.286C223.017 159.135 222.54 159.06 222.06 159.064C221.513 159.051 220.777 159.044 219.873 159.044H218.516L218.518 164.886ZM219.348 159.863H219.875C220.769 159.863 221.498 159.87 222.042 159.883C222.431 159.878 222.818 159.936 223.188 160.054C223.565 160.169 223.896 160.395 224.139 160.701C224.364 161.066 224.471 161.491 224.443 161.918C224.45 162.302 224.358 162.681 224.174 163.02C223.989 163.336 223.7 163.579 223.354 163.71C222.91 163.905 222.433 164.017 221.947 164.041C221.467 164.057 220.616 164.066 219.346 164.067L219.348 159.863Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.754 158.701C229.112 158.014 228.306 157.496 227.408 157.195C227.984 156.819 228.471 156.326 228.836 155.748C229.38 154.881 229.661 153.879 229.645 152.86C229.661 151.998 229.458 151.146 229.056 150.381C228.642 149.639 228.017 149.033 227.258 148.638C226.544 148.25 225.765 147.99 224.958 147.871C223.812 147.734 222.658 147.675 221.504 147.695H213.91V163.645C213.656 163.734 213.441 163.908 213.303 164.136C213.165 164.365 213.113 164.634 213.155 164.897C213.197 165.16 213.332 165.4 213.534 165.575C213.737 165.751 213.996 165.851 214.265 165.858C214.535 165.865 214.799 165.779 215.011 165.614C215.223 165.45 215.369 165.217 215.426 164.957C215.482 164.696 215.444 164.425 215.319 164.189C215.194 163.954 214.989 163.769 214.74 163.666V148.52H221.504C222.617 148.5 223.73 148.556 224.836 148.687C225.546 148.792 226.233 149.021 226.862 149.363C227.48 149.682 227.99 150.174 228.328 150.777C228.663 151.42 228.831 152.136 228.816 152.86C228.83 153.722 228.595 154.57 228.136 155.304C227.694 156.001 227.042 156.545 226.272 156.86L226.019 156.966V157.688L226.348 157.757C227.419 157.952 228.399 158.478 229.146 159.26C229.864 160.108 230.23 161.194 230.169 162.298C230.188 163.159 230.007 164.013 229.639 164.794C229.304 165.482 228.816 166.087 228.211 166.563C227.51 167.122 226.703 167.536 225.837 167.781C224.734 168.052 223.599 168.177 222.462 168.15H214.379V168.982H222.46C223.672 169.009 224.881 168.874 226.056 168.582C227.028 168.308 227.933 167.844 228.719 167.218C229.422 166.665 229.988 165.963 230.378 165.164C230.802 164.269 231.013 163.289 230.994 162.301C231.059 160.989 230.616 159.702 229.754 158.701V158.701Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.632 168.151H180.893V148.52H185.169V165.076H188.67C188.768 165.257 188.914 165.408 189.092 165.513C189.27 165.618 189.474 165.674 189.682 165.674C189.89 165.674 190.094 165.618 190.272 165.513C190.451 165.408 190.597 165.257 190.695 165.076L190.772 164.893C190.812 164.779 190.834 164.66 190.835 164.539C190.835 164.263 190.734 163.997 190.55 163.79C190.366 163.583 190.112 163.449 189.835 163.413C189.558 163.378 189.278 163.443 189.046 163.597C188.814 163.75 188.647 163.982 188.576 164.248H186V147.692H180.065V168.982H194.462V164.251H193.633L193.632 168.151Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.662 148.512C155.75 148.765 155.924 148.978 156.155 149.117C156.386 149.255 156.658 149.31 156.926 149.271C157.193 149.232 157.438 149.102 157.618 148.903C157.798 148.705 157.902 148.45 157.912 148.184C157.922 147.918 157.838 147.656 157.673 147.445C157.508 147.234 157.274 147.086 157.01 147.028C156.746 146.969 156.47 147.004 156.23 147.125C155.989 147.246 155.799 147.447 155.693 147.691H147.308V152.167H151.962V159.836C151.962 160.533 151.951 161.181 151.929 161.761C151.919 162.24 151.811 162.712 151.614 163.149C151.444 163.524 151.145 163.827 150.771 164.006C150.176 164.26 149.529 164.373 148.882 164.338C148.344 164.353 147.806 164.289 147.288 164.148C146.854 164.012 146.431 163.863 146.033 163.705L145 163.671V168.506L145.329 168.575C146.035 168.718 146.749 168.818 147.467 168.874C148.267 168.943 149.134 168.977 150.042 168.977C151.169 168.993 152.293 168.841 153.374 168.525C154.326 168.236 155.203 167.745 155.943 167.085C156.599 166.502 157.105 165.773 157.418 164.959C157.739 164.122 157.901 163.235 157.896 162.34V152.092H157.066V162.342C157.072 163.135 156.928 163.923 156.644 164.665C156.377 165.359 155.946 165.981 155.387 166.479C154.736 167.058 153.964 167.49 153.125 167.744C152.125 168.035 151.085 168.175 150.042 168.158C149.152 168.158 148.311 168.125 147.539 168.059C146.913 168.005 146.34 167.934 145.83 167.839V164.51C146.216 164.661 146.622 164.803 147.036 164.933C147.636 165.1 148.259 165.178 148.882 165.162C149.662 165.201 150.441 165.055 151.153 164.736C151.692 164.473 152.121 164.033 152.367 163.492C152.609 162.958 152.741 162.381 152.754 161.797C152.777 161.211 152.788 160.552 152.788 159.839V151.346H148.137V148.512H155.662Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.703 156.395C223.142 156.167 223.489 155.798 223.687 155.349C223.893 154.876 223.996 154.366 223.988 153.852C224.016 153.265 223.887 152.681 223.616 152.158C223.367 151.739 222.987 151.41 222.533 151.22C222.171 151.071 221.782 150.996 221.389 150.998C220.948 150.985 220.35 150.979 219.618 150.979H218.519V156.82H219.076C220.177 156.82 220.911 156.811 221.322 156.793C221.806 156.764 222.278 156.628 222.703 156.395V156.395ZM219.191 156.001V151.797H219.618C220.342 151.797 220.932 151.804 221.373 151.817C221.691 151.813 222.006 151.871 222.301 151.988C222.621 152.117 222.891 152.344 223.07 152.635C223.256 153.013 223.341 153.432 223.317 153.852C223.324 154.23 223.25 154.605 223.1 154.953C222.966 155.252 222.732 155.496 222.437 155.644C222.087 155.836 221.697 155.949 221.297 155.974C220.908 155.991 220.219 156 219.189 156.001H219.191Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9596 87.8248C22.3096 87.8248 21.6096 87.7248 21.1846 87.5998L20.9346 84.0998C21.5846 84.2748 22.0596 84.3248 22.5846 84.3248C23.9846 84.3248 24.4596 83.5998 24.4596 81.8748V68.2498H27.9596V78.8248H30.6596V82.3248H27.9346C27.7346 86.1748 26.2596 87.8248 22.9596 87.8248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9449 87.6498C31.8949 87.6498 30.9949 87.0248 30.9949 85.8748C30.9949 84.7998 31.8449 84.0748 32.9449 84.0748C34.0449 84.0748 34.8949 84.7998 34.8949 85.8748C34.8949 87.0248 33.9949 87.6498 32.9449 87.6498ZM38.3699 87.6498C37.3199 87.6498 36.4199 87.0248 36.4199 85.8748C36.4199 84.7998 37.2699 84.0748 38.3699 84.0748C39.4949 84.0748 40.3199 84.7998 40.3199 85.8748C40.3199 87.0248 39.4199 87.6498 38.3699 87.6498ZM30.1699 82.3248V78.8248H35.3949V68.2498H38.8949V82.3248H30.1699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.5895 87.8248C42.9395 87.8248 42.2395 87.7248 41.8145 87.5998L41.5645 84.0998C42.2145 84.2748 42.6895 84.3248 43.2145 84.3248C44.6145 84.3248 45.0895 83.5998 45.0895 81.8748V68.2498H48.5895V81.3748C48.5895 85.8998 47.1645 87.8248 43.5895 87.8248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.3418 82.3248V62.0498H56.8418V78.8248H60.0418V82.3248H53.3418Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.54 82.3248V78.8248H62.89C62.165 77.8748 61.69 76.6998 61.69 75.2748C61.69 70.8748 65.09 68.2498 70.09 68.2498H74.215V78.8248H76.515V82.3248H59.54ZM65.19 75.2748C65.19 76.7998 65.94 78.0248 67.09 78.8248H70.715V71.7498H69.24C67.215 71.7498 65.19 72.9748 65.19 75.2748ZM71.79 66.1248C70.74 66.1248 69.84 65.4998 69.84 64.3248C69.84 63.2748 70.69 62.5498 71.79 62.5498C72.915 62.5498 73.74 63.2748 73.74 64.3248C73.74 65.4998 72.84 66.1248 71.79 66.1248ZM66.365 66.1248C65.315 66.1248 64.415 65.4998 64.415 64.3248C64.415 63.2748 65.265 62.5498 66.365 62.5498C67.465 62.5498 68.315 63.2748 68.315 64.3248C68.315 65.4998 67.415 66.1248 66.365 66.1248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.0195 82.3248V78.8248H81.2445V68.2498H84.7445V78.8248H89.3445V82.3248H76.0195ZM85.5445 66.1248C84.4945 66.1248 83.5945 65.4998 83.5945 64.3248C83.5945 63.2748 84.4445 62.5498 85.5445 62.5498C86.6695 62.5498 87.4945 63.2748 87.4945 64.3248C87.4945 65.4998 86.5945 66.1248 85.5445 66.1248ZM80.1195 66.1248C79.0695 66.1248 78.1695 65.4998 78.1695 64.3248C78.1695 63.2748 79.0195 62.5498 80.1195 62.5498C81.2195 62.5498 82.0695 63.2748 82.0695 64.3248C82.0695 65.4998 81.1695 66.1248 80.1195 66.1248Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8369 82.3248V78.8248H91.2869V62.0498H94.7869V82.3248H88.8369Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9238 82.3248V62.0498H103.424V82.3248H99.9238Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.8096 117.325L29.8596 109.325H26.2846V117.325H22.6846V97.0498H30.2846C35.5596 97.0498 37.6846 100.05 37.6846 103.175C37.6846 105.5 36.5846 107.825 33.5596 108.825L38.8596 117.325H34.8096ZM29.4846 100.4H26.2846V106.2H29.4846C32.1346 106.2 33.8846 105.6 33.8846 103.25C33.8846 101.225 32.4596 100.4 29.4846 100.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.1461 114.2H48.5211C49.9961 114.2 51.8961 113.65 52.6461 112.95L54.1961 116.075C52.6961 116.9 50.8211 117.625 48.0461 117.625C43.5961 117.625 40.3211 114.425 40.3211 110.2C40.3211 105.85 43.6461 102.75 47.7961 102.75C52.1211 102.75 55.2461 105.925 55.0711 111.35H43.9211C44.3711 113.275 45.9711 114.2 48.1461 114.2ZM47.7461 105.85C45.8711 105.85 44.4711 106.95 44.0461 108.45H51.3961C51.0211 106.725 49.6461 105.85 47.7461 105.85Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.3053 106.475V113.925C62.1553 114.125 62.8553 114.2 63.5053 114.2C66.2553 114.2 68.0303 112.875 68.0303 110.175C68.0303 107.45 66.2553 106.175 63.5053 106.175C62.8053 106.175 62.0803 106.3 61.3053 106.475ZM61.3053 117.425V122.825H57.8053V103.5C59.5303 103 61.4553 102.75 63.4553 102.75C68.6553 102.75 71.6803 105.975 71.6803 110.175C71.6803 114.375 68.5553 117.625 63.7303 117.625C63.1053 117.625 62.2803 117.575 61.3053 117.425Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.7107 117.625C77.3857 117.625 74.0857 114.4 74.0857 110.2C74.0857 106.025 77.3857 102.75 81.7107 102.75C86.0357 102.75 89.3357 106.025 89.3357 110.2C89.3357 114.4 86.0357 117.625 81.7107 117.625ZM81.7107 114.2C84.1607 114.2 85.6607 112.425 85.6607 110.2C85.6607 108 84.1607 106.175 81.7107 106.175C79.2607 106.175 77.7607 108 77.7607 110.2C77.7607 112.425 79.2607 114.2 81.7107 114.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.355 103.025V106.375H98.3553C97.8053 106.375 96.1053 106.475 95.6803 106.625V117.325H92.1803V103.625C93.9303 103.275 96.2553 103.025 97.7053 103.025H100.355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.617 106.5V103.25H104.267V98.0998H107.767V103.25H113.117V106.5H107.767V111.6C107.767 113.5 108.417 114.075 110.267 114.075H113.217V117.325H109.892C105.992 117.325 104.267 116.225 104.267 112.85V106.5H101.617Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.375 117.325V103.25H119.875V117.325H116.375ZM118.125 101.05C117.025 101.05 116.075 100.4 116.075 99.1748C116.075 98.0748 116.95 97.3248 118.125 97.3248C119.3 97.3248 120.15 98.0748 120.15 99.1748C120.15 100.3 119.325 101.05 118.125 101.05Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.894 117.325V103.475C126.069 103.075 128.694 102.75 130.219 102.75C133.819 102.75 136.719 103.9 136.719 108.525V117.325H133.219V109.525C133.219 106.95 132.144 106.175 130.069 106.175C129.319 106.175 128.394 106.275 127.394 106.45V117.325H123.894Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.671 113.575V106.475C148.896 106.3 148.171 106.175 147.496 106.175C144.746 106.175 142.971 107.375 142.971 110C142.971 112.6 144.746 113.85 147.496 113.85C148.121 113.85 148.821 113.775 149.671 113.575ZM139.296 110C139.296 105.875 142.321 102.75 147.521 102.75C149.546 102.75 151.446 103 153.171 103.5V116.25C153.171 121.225 151.421 122.95 145.846 122.95C144.746 122.95 142.921 122.675 141.796 122.325L141.046 118.675C142.421 119.275 144.621 119.725 145.996 119.725C148.146 119.725 149.671 119.025 149.671 117.375V117.075C148.721 117.225 147.871 117.275 147.246 117.275C142.446 117.275 139.296 114.125 139.296 110Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M197.849 -14.9819C193.941 23.4956 209.44 104.179 302.376 120.366M302.376 120.366C302.772 120.435 303.169 120.502 303.569 120.569C397.565 136.27 341.938 126.975 302.376 120.366Z",
    stroke: "white",
    strokeWidth: 1.57009
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M149.627 -1.96711C165.56 33.274 219.464 95.2776 307.969 62.6286M307.969 62.6286C308.346 62.4894 308.724 62.3485 309.103 62.2058C398.281 28.6048 345.504 48.4873 307.969 62.6286Z",
    stroke: "white",
    strokeWidth: 1.57009
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_5438_171247",
    x: -284,
    y: -234,
    width: 569,
    height: 569,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.316718 0 0 0 0 0.0126224 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5438_171247"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.26443
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5438_171247",
    result: "effect2_dropShadow_5438_171247"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5438_171247",
    result: "effect3_dropShadow_5438_171247"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5438_171247",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ddd_5438_171247",
    x: -208,
    y: -157,
    width: 416,
    height: 416,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.316718 0 0 0 0 0.0126224 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5438_171247"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.26443
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5438_171247",
    result: "effect2_dropShadow_5438_171247"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5438_171247",
    result: "effect3_dropShadow_5438_171247"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5438_171247",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ddd_5438_171247",
    x: -148,
    y: -97,
    width: 296,
    height: 296,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.39155
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.678431 0 0 0 0 0.316718 0 0 0 0 0.0126224 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5438_171247"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11.3915
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.26443
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.02 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_5438_171247",
    result: "effect2_dropShadow_5438_171247"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 51
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.945098 0 0 0 0 0.501961 0 0 0 0 0.129412 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_5438_171247",
    result: "effect3_dropShadow_5438_171247"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_5438_171247",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5438_171247",
    x1: 0,
    y1: 0,
    x2: 246,
    y2: 185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.169792,
    stopColor: "#EE8B98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.784375,
    stopColor: "#EB445A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5438_171247"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246,
    height: 185,
    rx: 4,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportingCard);
export default __webpack_public_path__ + "static/media/reportingCard.7c7805d37447b51ed2c0592b131d9224.svg";
export { ForwardRef as ReactComponent };